import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Klima = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <g fill="none" fillRule="evenodd">
      <circle fill="#FFA86A" cx="24" cy="24" r="24" />
      <path
        d="M24 14c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L21 27v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1v-2h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>{' '}
  </SvgIcon>
);

export default Klima;
